module.exports = __webpack_public_path__ + "img/platform.551780e5.png";